import {useEffect, useState} from "react";
import FunctionsData from "../../../Functions/FunctionsData";
import {Button, Drawer, FormControl, FormControlLabel, Stack, Switch, TextField} from "@mui/material";
import {LanguageConfig} from "../../../Functions/LanguageConfig";
import {Input} from "baseui/input";
import * as React from "react";

export default function StaffSponsorsAddSponsorCode({mode, currentData, isOpen,setIsOpen,active,setLoading}) {

    const emailTextTemplate = "You won't need to pay anything at the veterinary clinic at the time of your appointment."
    const date = new Date();
    const [frmName, setFrmName] = useState(currentData.name || '');
    const [frmNameProgram, setFrmNameProgram] = useState(currentData.program || '');
    const [frmMaxSpend, setFrmMaxSpend] = useState(currentData.max_spent || 1000);
    const [frmMaxVouchers,setFromMaxVouchers]=useState(currentData.max_vouchers|| 0);
    const [frmVouchersLeft,setFromVouchersLeft]=useState(currentData.total_vouchers_left||frmMaxVouchers);
    const [frmCost, setFrmCost] = useState(currentData.applicant_cost || 20);
    const [frmMicrochipExtraCost, setFrmMicrochipExtraCost] = useState(currentData.microchip_extra_cost || 15);
    const [frmEmailText, setFrmEmailText] = useState(currentData.email_text || emailTextTemplate);
    const [frmDateFrom, setFrmDateFrom] = useState(new Date().toISOString().slice(0, 10));
    const [frmDateTo, setFrmDateTo] = useState(new Date(date.setMonth(date.getMonth()+1)).toISOString().slice(0, 10));
    const [frmURL, setFrmURL] = useState(currentData.url || '');
    const [optoutPublic, setOptoutPublic] = useState(false);
    const [optoutCommunity, setOptoutCommunity] = useState(false);

    useEffect(() => {

        setFrmCost(currentData.applicant_cost   ?? 20);
        setFrmMicrochipExtraCost(currentData.microchip_extra_cost ?? 15);
        setFrmMaxSpend(currentData.max_spent || 1000);
        setFromMaxVouchers(currentData.max_vouchers||50);
        setFrmEmailText(currentData.email_text || emailTextTemplate);
        setFrmNameProgram(currentData.program || '');
        setFrmName(currentData.name || '');
        setOptoutPublic(currentData.optout_public === 1 || false);
        setOptoutCommunity(currentData.optout_community === 1 || false);

        if (typeof currentData.start_date !== 'undefined') {
            setFrmDateFrom(currentData.start_date.slice(0, 10));
        }

        if (typeof currentData.end_date !== 'undefined') {
            setFrmDateTo(currentData.end_date.slice(0, 10));
        }

    }, [])

    useEffect(() => {

    }, [])

    async function submit() {

        const tkn = await FunctionsData.getCSRFToken();
        let requestOptionsVoucher = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'token': sessionStorage.sTkn,
                'X-CSRF-Token': tkn.csrf
            },
            body: JSON.stringify(
                {
                    name: frmName,
                    start_date: frmDateFrom,
                    end_date: frmDateTo,
                    max_spent: frmMaxSpend,
                    applicant_cost: frmCost,
                    microchip_extra_cost: frmMicrochipExtraCost,
                    program: frmNameProgram,
                    email_text: frmEmailText,
                    email_text_url: frmEmailText.replace(/##url##/g, '<a href="'+frmURL+'" target="_blank">'+frmName+'</a>'),
                    url: frmURL,
                    max_vouchers:frmMaxVouchers,
                    active: (mode === 'new') ? 1 : active,
                    optout_public:(optoutPublic) ? 1 : 0,
                    optout_community:(optoutCommunity) ? 1 : 0,
                })
        };


        if (mode === "new") {
            await fetch(FunctionsData.getApiUrl("/api/sponsors/"), requestOptionsVoucher)
                .then(response => response.json())
                .then((res) => {
                    setLoading(true);
                    setIsOpen(false);
                })
        } else {
            await fetch(FunctionsData.getApiUrl("/api/sponsors/update/") + (currentData.id || 0), requestOptionsVoucher)
                .then(response => response.json())
                .then((res) => {
                    setLoading(true);
                    setIsOpen(false);
                })
        }

    }

    function handleDayClick(e, fn) {
        fn(e.target.value)
    }

    return (
        <Drawer
            open={isOpen}
            anchor={"right"}
            autoFocus
            onClose={() => setIsOpen(false)}
        >
            <div style={{padding:20}}>
                <h1>{(mode === 'new') ? "Add a new sponsor" : "Modify an existing sponsor"}</h1>
                <div style={{marginTop: 20}}>

                    <div><FormControlLabel control={<Switch checked={!optoutPublic} onChange={() => setOptoutPublic(!optoutPublic)} />} label="Snip'nChip" /></div>
                    <div><FormControlLabel control={<Switch checked={!optoutCommunity} onChange={() => setOptoutCommunity(!optoutCommunity)} />} label="Community" /></div>

                    <FormControl fullWidth sx={{marginBottom: 2, marginTop:2}}>
                        <TextField
                            error={frmName === ''}
                            label={LanguageConfig.StaffSponsorCodes_SponsorName}
                            type="text"
                            aria-describedby="component-helper-text"
                            value={frmName}
                            onChange={(e) => setFrmName(e.target.value)}
                            focused
                        />
                    </FormControl>


                    <FormControl fullWidth sx={{marginBottom: 2}}>
                        <TextField
                            error={frmNameProgram === ''}
                            label={LanguageConfig.StaffSponsorCodes_SponsorProgram}
                            type="text"
                            aria-describedby="component-helper-text"
                            value={frmNameProgram}
                            onChange={(e) => setFrmNameProgram(e.target.value)}
                            focused
                        />
                    </FormControl>

                    <FormControl fullWidth sx={{marginBottom: 2}}>
                        <TextField
                            error={frmURL === ''}
                            label={LanguageConfig.StaffSponsorCodes_SponsorUrl}
                            type="text"
                            aria-describedby="component-helper-text"
                            value={frmURL}
                            onChange={(e) => setFrmURL(e.target.value)}
                            focused
                        />
                    </FormControl>

                    <h3>Program start</h3>
                    <FormControl fullWidth sx={{marginBottom: 2}}>
                        <Input error={frmDateFrom === ''} type={"date"} value={frmDateFrom}
                               onChange={(e) => handleDayClick(e, setFrmDateFrom)}/>
                    </FormControl>
                    <h3>Program end</h3>
                    <FormControl fullWidth sx={{marginBottom: 2}}>
                        <Input error={frmDateTo === ''} type={"date"} value={frmDateTo}
                               onChange={(e) => handleDayClick(e, setFrmDateTo)}/>
                    </FormControl>

                    <Stack direction={"row"}>
                        <FormControl fullWidth sx={{marginBottom: 2}}>
                            <TextField
                                error={frmCost === ''}
                                label={LanguageConfig.StaffSponsorCodes_SponsorCost}
                                type="number"
                                aria-describedby="component-helper-text"
                                value={frmCost}
                                onChange={(e) => setFrmCost(e.target.value)}
                                focused
                                sx={{marginRight:2}}
                            />
                        </FormControl>
                        <FormControl fullWidth sx={{marginBottom: 2}}>
                            <TextField
                                error={frmMicrochipExtraCost === ''}
                                label={LanguageConfig.StaffSponsorCodes_SponsorCostMicrochip}
                                type="number"
                                aria-describedby="component-helper-text"
                                value={frmMicrochipExtraCost}
                                onChange={(e) => setFrmMicrochipExtraCost(e.target.value)}
                                focused
                                sx={{marginRight:2}}
                            />
                        </FormControl>
                        <FormControl fullWidth sx={{marginBottom: 2}}>
                            <TextField
                                error={frmMaxSpend === ''}
                                label={LanguageConfig.StaffSponsorCodes_SponsorMaxSpent}
                                type="number"
                                aria-describedby="component-helper-text"
                                value={frmMaxSpend}
                                onChange={(e) => setFrmMaxSpend(e.target.value)}
                                focused
                            />
                        </FormControl>
                    </Stack>
                <Stack direction={"row"}>
                        <FormControl fullWidth sx={{marginBottom: 2}}>
                            <TextField
                                error={frmMaxVouchers === ''}
                                label={LanguageConfig.StaffSponsorCodes_SponsorMaxVouchers}
                                type="number"
                                aria-describedby="component-helper-text"
                                value={frmMaxVouchers}
                                onChange={(e) => setFromMaxVouchers(e.target.value)}
                                focused
                                sx={{marginRight:2}}
                            />
                        </FormControl>
                    </Stack>

                    <FormControl fullWidth sx={{marginBottom: 2}}>
                        <TextField
                            error={frmEmailText === ''}
                            label={LanguageConfig.StaffSponsorCodes_SponsorEmailText}
                            type="text"
                            aria-describedby="component-helper-text"
                            value={frmEmailText}
                            onChange={(e) => setFrmEmailText(e.target.value)}
                            focused
                            multiline={10}
                        />
                        <small>Use ##url## to insert a name that links to the sponsor website. </small>
                    </FormControl>

                    <Button variant={"contained"}
                            disabled={(
                                frmName === '' ||
                                frmNameProgram === '' ||
                                frmDateTo === '' ||
                                frmDateFrom === '' ||
                                frmMaxSpend === 0 ||
                                frmEmailText === '' ||
                                frmURL === ''
                            )}
                            onClick={submit}
                    >
                        Save sponsor
                    </Button>
                    <Button variant={""} sx={{marginLeft: 1}} onClick={() => setIsOpen(false)}>Cancel</Button>
                </div>
            </div>
        </Drawer>
    );
}
